import React, { useContext, useState } from "react";
import { FirebaseContext } from "../contexts/FirebaseContext";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";

function AuthScreen() {
  const { firebaseAuth } = useContext(FirebaseContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (!email || !password) {
      alert("Please fill out both fields.");
      return;
    }

    signInWithEmailAndPassword(firebaseAuth, email, password)
      .then((userCredential) => {
        console.log("User logged in:", userCredential.user);
        navigate("/home");
      })
      .catch((error) => {
        console.error("Error logging in:", error);
        alert("Failed to log in: " + error.message);
      });
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleLogin} style={styles.formContainer}>
        <h1 style={styles.heading}>Auth Screen</h1>
        <input
          id="email"
          type="email"
          placeholder="Email"
          aria-label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />
        <input
          id="password"
          type="password"
          placeholder="Password"
          aria-label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>
          Login
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    backgroundColor: "var(--bg)",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "400px",
    padding: "20px",
    backgroundColor: "var(--surface)",
    color: "var(--text)",
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "24px",
    color: "var(--text)",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "12px",
    borderRadius: "4px",
    border: "1px solid var(--border)",
    backgroundColor: "var(--bg)",
    color: "var(--text)",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "var(--primary)",
    color: "#fff",
    borderRadius: "4px",
    border: "none",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default AuthScreen;
